import CircularProgress from '@mui/material/CircularProgress'
import snail from 'assets/image/snail-looking-for.png'
import clsx from 'clsx'
import { useAppSelector } from 'shared/hooks'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import { useOpenContacts } from '../hooks/useOpenContacts'
import css from './style.module.scss'

export function Launch({
	onLaunch
}: {
	onLaunch: () => void
}) {
	const isLoading = useAppSelector(state => state.app.tableContentLoader)
	const openContacts = useOpenContacts()

	return (
		<div className={css.root}>
			<main className={css.card}>
				<h2 className={clsx(css.title, typo.subtitle)}>
					Ready to go! <br /> Launch it?
				</h2>

				<img alt='snail' className={css.img} src={snail} width={150} />
				<span className={clsx(css.lead, typo.buttonSm)}>
					You can add more contacts or launch it now.
				</span>

				<div className={css.buttons}>
					<Button
						className={css.button}
						onClick={openContacts}
						type='button'
						typography={typo.largeButton}
						variant='bordered-dark'
					>
						Add more contacts
					</Button>

					<Button
						onClick={onLaunch}
						type='button'
						typography={typo.largeButton}
					>
						{isLoading ? (
							<CircularProgress color='primary' size={20} />
						) : (
							'Launch'
						)}
					</Button>
				</div>
			</main>
		</div>
	)
}
